import { useState } from 'react';
import { faqList } from '@/mocks/manga';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center gap-2 mb-3">
            <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              常见问题
            </h2>
            <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          </div>
          <p className="text-sm text-foreground-500">关于樱花漫画的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 text-left cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}